<template>
  <div class="search">
    <!-- 搜索input框 -->
    <el-input v-model="input" :placeholder="Tips||val" style="width: 500px;"></el-input>
    <!-- 搜索按钮 -->
    <div class="search_btn" @click="handelScreen">
      <div>
        <i class="el-icon-search" style="font-size: 20px;margin-right: 5px;"></i>
        <span>搜索</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "Login",
  // 组件参数 接收来自父组件的数据
  props: {
    Tips: {},
    val: {},
  },
 
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      input: "",
    };
  },
  // 组件初始化
  created() {},
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    // 搜索
    handelScreen() {
      this.$emit("handelScreen", this.input);
    },
  },
};
</script>

<style scoped lang="less">
// 搜索大div
.search {
  width: 600px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  // 修改 el组件库input框的样式
  /deep/.el-input__inner {
    width: 500px;
    height: 40px !important;
    font-size: 14px;
    line-height: 50px;
    box-sizing: border-box;
    border: 2.2px solid #409eff ;
    background: #ffffff;
    border-radius: 10px;
    position: relative;
    z-index: 899;
  }
  // 搜索按钮样式
  .search_btn {
    font-size: 14px;
    color: #ffffff;
    font-weight: 400;
    line-height: 40px;
    background-color: #409eff ;
    width: 107px;
    height: 40px;
    box-sizing: border-box;
    border: 2.2px solid #409eff ;
    border-radius: 0px 10px 10px 0px;
    cursor: pointer;
    display: flex;
    white-space: nowrap;
    position: absolute;
    right: 0;
    div {
      width: 60px;
      height: 20px;
      line-height: 20px;
      margin: auto;
      display: flex;
      align-items: center;
      // p {
      //   width: 20px;
      //   height: 20px;
      //   background-image: url("../../../../assets/imgs/sousuo@3x.svg");
      //   background-size: 100% 100%;
      //   margin-right: 3px;
      //   cursor: pointer;
      // }
    }
  }
}
</style>
